import "./style.css"

function LoaderWheel() {
    return (
        <div className="w-[20px] h-[20px] loader-wheel"></div>
    )
}
export default LoaderWheel;